import { EventBus } from 'core-components/classes/events/Bus'
import { registerSharedDependency } from 'core-components/helpers/MFHelper'

export enum CrudStoreEvents {
  onCrudChanged = 'onCrudChanged',
}

export const crudStoreEventBus = registerSharedDependency(
  'crudStoreEventBus',
  () => new EventBus([CrudStoreEvents.onCrudChanged], 'CrudStoreEventsBus')
)
